
































import _ from 'lodash';
import {
  computed,
  defineComponent,
  nextTick,
  Ref,
  ref,
  getCurrentInstance,
  ComponentInternalInstance,
  watch,
} from '@vue/composition-api';
import ConstantConfig from '@/renderer/scripts/utils/ConstantConfig';
import i18n, { i18n_t } from '@/locales/i18n';
export default defineComponent({
  props: {
    show: {
      required: true,
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    const { fileNameMaxLength: folderNameMaxLength } = ConstantConfig;
    const name = ref(i18n_t('新建文件夹'));
    const validateShow = ref(false);
    const validateTip = ref('');
    const currComponent = getCurrentInstance() as ComponentInternalInstance;
    const methods = {
      submit() {
        if (validateShow.value || !name.value.trim()) return;
        context.emit('onSubmit', name.value.trim());
      },
    };
    const validateName = (name: string) => {
      // 代表文件夹名称仅含.
      const dotRex = /^\.{1,}$/;
      if (name.trim().length > folderNameMaxLength) {
        validateShow.value = true;
        validateTip.value = i18n_t('名称长度需控制在 {slot1} 字以内', { slot1: folderNameMaxLength });
      } else if (name.indexOf('/') !== -1) {
        validateShow.value = true;
        validateTip.value = i18n_t('名称不支持字符“/”');
      } else if (name.trim() === '') {
        validateShow.value = true;
        validateTip.value = i18n_t('名称不能为空');
      } else if (dotRex.test(name)) {
        validateShow.value = true;
        validateTip.value = i18n_t('名称不可仅包含特殊字符“.”');
      } else {
        validateShow.value = false;
      }
    };
    const throttleValidate = _.throttle(validateName, 500);
    watch(innerShow, (value: Ref<unknown>) => {
      if (value) {
        name.value = i18n_t('新建文件夹');
        nextTick(() => {
          const { createFolderInput }: any = (currComponent as ComponentInternalInstance).refs;
          const inputDom = createFolderInput?.$el.children[0]?.children[0] as HTMLInputElement;
          inputDom && inputDom?.select();
        });
      } else {
        validateShow.value = false;
        validateTip.value = '';
      }
    });
    return {
      innerShow,
      validateShow,
      validateName,
      throttleValidate,
      validateTip,
      name,
      folderNameMaxLength,
      ...methods,
    };
  },
});
